"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HollywoodSquaresMap = void 0;
exports.HollywoodSquaresMap = {
    "1 / 2": 0,
    "2 / 3": 1,
    "2 / 1": 2,
    "3 / 2": 3,
    "1 / 3": 4,
    "3 / 3": 5,
    "3 / 1": 6,
    "1 / 1": 7,
    "2 / 2": 8,
};
//# sourceMappingURL=HollywoodSquaresMap.js.map